export enum ChatTabs {
  All = 'all',
  Me = 'me',
  Closed = 'closed',
}

export enum ChatSubTabs {
  Open = 'open',
  Invited = 'invited',
  Waiting = 'waiting',
}

export enum ChatBadgeTabs {
  UnreadMessages = 'unreadMessages',
  NewAssignments = 'newAssignments',
}
